import { useEffect, useState } from "react";
import axios from "axios";
import { CheckCircle2, ShieldAlert, Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/login-history`;

const KINDS = {
  success: { label: "Signed in", Icon: CheckCircle2, cls: "text-[#2F6B4F]" },
  failed_password: { label: "Wrong password", Icon: ShieldAlert, cls: "text-[#B4552F]" },
  failed_code: { label: "Wrong code", Icon: ShieldAlert, cls: "text-[#B4552F]" },
  locked: { label: "Locked for 15 min", Icon: Lock, cls: "text-[#8A2E1E]" },
};

const device = (ua = "") => {
  const browser = /Edg\//.test(ua) ? "Edge" : /Chrome\//.test(ua) ? "Chrome" : /Firefox\//.test(ua) ? "Firefox"
    : /Safari\//.test(ua) ? "Safari" : "Unknown browser";
  const os = /iPhone/.test(ua) ? "iPhone" : /iPad/.test(ua) ? "iPad" : /Android/.test(ua) ? "Android"
    : /Mac OS X/.test(ua) ? "Mac" : /Windows/.test(ua) ? "Windows" : /Linux/.test(ua) ? "Linux" : "Unknown device";
  return `${browser} on ${os}`;
};

const EventRow = ({ e, fmtDate }) => {
  const k = KINDS[e.kind] || KINDS.success;
  return (
    <li data-testid={`login-event-${e.id}`} className="grid grid-cols-1 md:grid-cols-[180px_1fr_1fr_1fr] gap-1 md:gap-6 border-t border-black/10 py-4 text-sm">
      <span className={`inline-flex items-center gap-2 ${k.cls}`} data-testid={`login-event-kind-${e.id}`}>
        <k.Icon size={15} /> {k.label}
      </span>
      <span className="text-[#111413]">{fmtDate(e.at)}</span>
      <span className="text-[#4A524D]">{e.location || "Location unknown"} · {e.ip}</span>
      <span className="text-[#4A524D]" title={e.user_agent}>{device(e.user_agent)}</span>
    </li>
  );
};

export const AdminLoginHistory = ({ fmtDate }) => {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    axios.get(API, { withCredentials: true }).then(({ data }) => setEvents(data)).catch(() => setEvents([]));
  }, []);

  return (
    <section className="mt-10" data-testid="admin-login-history">
      <h2 className="font-serif text-2xl tracking-tight text-[#111413]">Recent sign-in activity</h2>
      <p className="mt-1 text-sm text-[#4A524D]">Successful and failed attempts from the last 90 days. Locations are approximate.</p>
      {events === null ? (
        <p className="mt-4 text-sm text-[#4A524D]">Loading…</p>
      ) : events.length === 0 ? (
        <p className="mt-4 text-sm text-[#4A524D]" data-testid="admin-login-history-empty">No sign-in activity recorded yet.</p>
      ) : (
        <ul className="mt-4 border-b border-black/10">
          {events.map((e) => <EventRow key={e.id} e={e} fmtDate={fmtDate} />)}
        </ul>
      )}
    </section>
  );
};
